var map = {
	"./1.jpg": 5176,
	"./10.jpg": 7214,
	"./11.jpg": 8142,
	"./12.jpg": 9440,
	"./2.jpg": 2132,
	"./3.jpg": 2579,
	"./4.jpg": 3561,
	"./5.jpg": 9836,
	"./6.jpg": 4855,
	"./7.jpg": 6164,
	"./8.jpg": 7264,
	"./9.jpg": 1782,
	"./old_5.jpg": 4138,
	"./portada.jpg": 1563
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7960;